import { all, call, put, race, take } from 'redux-saga/effects';
import { fetchAll, requestHandler } from '../../../service/fetcher.saga';
import { checkAndInitDb, decodeAccessToken } from '../../../service/auth/saga';
import moment from 'moment';
import { delay } from 'redux-saga';
import { notify } from '../../Notifier/services/saga';
import { I18n } from 'react-redux-i18n';
import { setUser } from '../../../service/user/saga';
import { UPDATE_USER } from '../../../service/user/types';

/**
 * La propriété nofetch n'est utilité que pour l'onboarding master (on a juste besoin de recup l'access/refreshtoken). Dans un cas d'utilisation classique il ne faut pas qu'il soit a TRUE
 */
export function* selectChild() {
	while (true) {
		const { id, nofetch } = yield take('SELECT_CHILD');
		let _success = false;
		if (!id) {
			// on repasse en master
			if (getChildId()) {
				yield put({ type: UPDATE_USER, user: { connectedAs: null } });
				logoutChild();
				if (!nofetch) yield call(fetchAll);
			}
		} else {
			// selection d'un child qui n'était pas deja selectioné
			if (getChildId() !== id) {
				yield put({ type: 'LOGIN_CHILD', id });
				const { success } = yield take('LOGIN_CHILD_FINISHED');
				_success = success;
				if (success && !nofetch) {
					yield call(fetchAll);
				}
				if (!success) {
					yield call(errorLoginChild, nofetch);
				}
			}
		}
		yield put({ type: 'SELECT_CHILD_FINISHED', success: _success });
	}
}

export const getChildId = () => window.sessionStorage.id_child;
const setChildId = id => {
	if (id) window.sessionStorage.id_child = id;
	else window.sessionStorage.removeItem('id_child');
};
const setChildAccessToken = token => {
	if (token) window.sessionStorage.child_access_token = token;
	else window.sessionStorage.removeItem('child_access_token');
};
const setChildRefreshToken = token => {
	if (token) window.sessionStorage.child_refresh_token = token;
	else window.sessionStorage.removeItem('child_refresh_token');
};

function* errorLoginChild(nofetch = false) {
	yield call(notify, I18n.t('master.login_error'), 'error', 5000);
	yield put({ type: UPDATE_USER, user: { connectedAs: null } });
	logoutChild();

	if (!nofetch) yield call(fetchAll);
}

function* loginChild() {
	while (true) {
		let access_token = window.sessionStorage.getItem('child_access_token');
		let token_expires_wait_before_update_millisecond = 3600000; // on mets une heure par defaut, c'est juste pour avoir une valeur
		if (access_token) {
			const decoded = yield call(decodeAccessToken, access_token);
			const token_expires_timestamp = decoded.exp;
			const CurrentDate = moment().unix();
			const token_expires_wait_before_update =
				token_expires_timestamp - CurrentDate;
			token_expires_wait_before_update_millisecond =
				token_expires_wait_before_update * 1000;
			yield put({ type: UPDATE_USER, user: { connectedAs: decoded } });
		}

		const { expired, login } = yield race({
			expired: delay(token_expires_wait_before_update_millisecond),
			login: take('LOGIN_CHILD'),
		});

		let id = null;
		if (expired) id = getChildId();
		else if (login) id = login.id;

		if (id) {
			const result = yield call(connectAs, id);

			if (result && result.access_token && result.refresh_token) {
				const { refresh_token, access_token } = result;

				const decoded = yield call(decodeAccessToken, access_token);
				const { success } = yield call(
					checkAndInitDb,
					decoded,
					refresh_token,
					false
				);
				if (success) {
					const resultReReconnect = yield call(connectAs, id); // regeneration de l'access token qui contiendra la med db
					if (resultReReconnect && resultReReconnect.access_token)
						yield put({ type: 'LOGIN_CHILD_FINISHED', success: true });
				} else {
					yield call(errorLoginChild);
				}
			} else {
				yield call(errorLoginChild);
			}
		}
		yield put({ type: 'LOGIN_CHILD_FINISHED', success: false });
	}
}
export function logoutChild() {
	setChildId();
	setChildAccessToken();
	setChildRefreshToken();
}

export default function* MasterBarSaga() {
	yield all([selectChild(), loginChild()]);
}

function* connectAs(id) {
	const { result } = yield call(requestHandler, 'user/connect-as', 'POST', {
		id,
		refresh_token: window.localStorage.refresh_token,
	});

	if (result && result.access_token && result.refresh_token) {
		const { refresh_token, access_token } = result;
		setChildId(id);
		setChildAccessToken(access_token);
		setChildRefreshToken(refresh_token);
	}
	return result;
}
